import { Component, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Upload } from 'app/core/models/upload.model';
import { ArsConsultNoteImportsService } from 'app/core/services/ars-consult-note-imports.service';
import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';

@Component({
  selector: 'app-capture-admin-import-ars-consult-notes',
  templateUrl: './capture-admin-import-ars-consult-notes.component.html',
  imports: [ImportNavComponent, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportArsConsultNotesComponent {
  private arsConsultNoteImportsService = inject(ArsConsultNoteImportsService);

  uploading = false;
  errors: string[] = [];
  importedCount: number = null;

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
    this.importedCount = null;
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.arsConsultNoteImportsService.upload(upload.signedId).subscribe(
      result => {
        this.uploading = false;
        this.importedCount = result.arsConsultNoteImports.length;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error?.errors || ['An unexpected error occurred.'];
      }
    );
  }

  onUploadError() {
    this.uploading = false;
    this.errors = ['The file could not be uploaded.'];
  }

  get hasError() {
    return !isEmpty(this.errors);
  }
}
